import {
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import React, { useEffect, useRef, useState } from "react";
import Label from "../../../components/Label";

const libraries = ["places"];

const BusinessLocation = ({ handleSelect, inputValues }) => {
  const mapContainerStyle = { width: "100%", height: "500px" };
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDgm3VBE9YF9fIYqHU6Cue4OfJBtJBlxj4",
    libraries,
  });

  const [map, setMap] = useState(null);
  const [mapCenter, setMapCenter] = useState({
    lat: inputValues?.businessLat || 24.7136,
    lng: inputValues?.businessLng || 46.6753,
  });
  const [markerPosition, setMarkerPosition] = useState({
    lat: inputValues?.businessLat || 24.7136,
    lng: inputValues?.businessLng || 46.6753,
  });
  const [address, setAddress] = useState(inputValues?.businessAddress || "");
  const [suggestions, setSuggestions] = useState([]);
  const autocompleteService = useRef(null);

  useEffect(() => {
    if (!autocompleteService.current && window?.google) {
      autocompleteService.current =
        new window.google.maps.places.AutocompleteService();
    }
  }, [isLoaded]);

  useEffect(() => {
    if (
      inputValues?.businessLat &&
      inputValues?.businessLng &&
      inputValues?.businessAddress
    ) {
      const lat = Number(inputValues.businessLat);
      const lng = Number(inputValues.businessLng);
      const addr = inputValues.businessAddress;

      console.log("Updating marker position:", lat, lng, addr);

      setMarkerPosition({ lat, lng });
      setMapCenter({ lat, lng });
      setAddress(addr);

      if (map) {
        map.panTo({ lat, lng });
        map.setZoom(17);
      }
    }
  }, [inputValues, map]);

  const updateLocation = (lat, lng, addr) => {
    console.log("Location updated to:", lat, lng, addr);
    setMarkerPosition({ lat, lng });
    setMapCenter({ lat, lng });
    setAddress(addr);

    if (map) {
      map.panTo({ lat, lng });
      map.setZoom(17);
    }

    handleSelect({
      label: addr,
      value: addr,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setAddress(value);
    if (autocompleteService.current && value) {
      autocompleteService.current.getPlacePredictions(
        { input: value },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setSuggestions(predictions);
          } else {
            setSuggestions([]);
          }
        }
      );
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionSelect = (suggestion) => {
    setAddress(suggestion.description);
    setSuggestions([]);
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: suggestion.place_id }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        updateLocation(location.lat(), location.lng(), suggestion.description);
      }
    });
  };

  const handleMarkerDragEnd = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        updateLocation(lat, lng, results[0].formatted_address);
      } else {
        updateLocation(lat, lng, address);
      }
    });
  };

  return (
    <Box>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={8} md={10}>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "25px", mb: "15px" }}
          >
            Where is your business located
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "400", fontSize: "15px", mb: "15px" }}
          >
            Where can clients find you? Adjust the pin to the correct location.
          </Typography>

          <Label labelText="Location address" htmlFor="address" required />
          <TextField
            fullWidth
            value={address}
            onChange={handleInputChange}
            placeholder="Search location"
          />

          {suggestions.length > 0 && (
            <Paper
              elevation={2}
              sx={{
                position: "absolute",
                zIndex: 10,
                maxHeight: 300,
                overflowY: "auto",
                mt: 1,
              }}
            >
              <List>
                {suggestions.map((suggestion) => (
                  <React.Fragment key={suggestion.place_id}>
                    <ListItem
                      onClick={() => handleSuggestionSelect(suggestion)}
                    >
                      <ListItemButton>{suggestion.description}</ListItemButton>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                ))}
              </List>
            </Paper>
          )}

          <Box width="100%" overflow="hidden" mt={2}>
            {isLoaded && (
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={15}
                center={mapCenter}
                onLoad={(mapInstance) => {
                  setMap(mapInstance);
                  mapInstance.panTo(markerPosition);
                }}
                options={{
                  streetViewControl: false,
                  mapTypeControl: false,
                  fullscreenControl: false,
                  zoomControl: true,
                }}
              >
                <Marker
                  key={`${markerPosition.lat}-${
                    markerPosition.lng
                  }-${Date.now()}`}
                  position={markerPosition}
                  draggable
                  onDragEnd={handleMarkerDragEnd}
                />
              </GoogleMap>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BusinessLocation;
